// Static package fallback so prices render in the pre-rendered HTML (react-snap blocks the
// /api/config call during snapshot). Mirrors /api/config exactly; live config overrides on hydration.
// CommonJS so both the React app (import { DEFAULT_PACKAGES }) and the Node build scripts
// (require, e.g. scripts/gen-llms.js) read the same single source of truth — prices can't drift.
const DEFAULT_PACKAGES = {
  starter: { display_name: "Starter", sessions: 5, devices: 2, band: "NORMAL", turnaround_days: 3, prices: { INR: { display_minor: 999900 }, USD: { display_minor: 12900 } } },
  standard: { display_name: "Standard", sessions: 10, devices: 4, band: "NORMAL", turnaround_days: 3, prices: { INR: { display_minor: 1899900 }, USD: { display_minor: 24900 } } },
  deep: { display_name: "Deep", sessions: 20, devices: 6, band: "DEEP", turnaround_days: 5, prices: { INR: { display_minor: 3499900 }, USD: { display_minor: 44900 } } },
};

module.exports = { DEFAULT_PACKAGES };
